(function () {

    "use strict";


    HTimePickerWrapperComponent.$inject = [];
    function HTimePickerWrapperComponent() {
        var self = this;

        self.handleOptionSelect = function (option) {
            self.onOptionSelect({ option: option });
        };
    }

    var HTimePickerWrapperComponentOptions = {

        bindings: {
            name: '@',
            placeholder: '@',
            inputClass: '@',
            ngModel: "=",
            ngDisabled: "<",
            ngChange: '&',
            ngInputClass: "<",
            timeType: '@',
            timeFormat: '@',
            hourStep: '<',
            minuteStep: '<',
            minTime: '<',
            maxTime: '<',
            options: '<',
            onOptionSelect: '&',
            onMomentModelChange: '&',
            validateTime: '&?',
            appendText: '<',
            prependIcon: '<',
            date: '<',
        },
        controller: HTimePickerWrapperComponent,
        controllerAs: '$ctrl',
        template: '<h-timepicker\n' +
            '    name="{{$ctrl.name}}"\n' +
            '    placeholder="{{$ctrl.placeholder}}"\n' +
            '    input-class="{{$ctrl.inputClass}}"\n' +
            '    ng-model="$ctrl.ngModel"\n' +
            '    ng-disabled="$ctrl.ngDisabled"\n' +
            '    ng-change="$ctrl.ngChange()"\n' +
            '    ng-input-class="$ctrl.ngInputClass"\n' +
            '    time-type="{{$ctrl.timeType}}"\n' +
            '    time-format="{{$ctrl.timeFormat}}"\n' +
            '    hour-step="$ctrl.hourStep"\n' +
            '    minute-step="$ctrl.minuteStep"\n' +
            '    min-time="$ctrl.minTime"\n' +
            '    max-time="$ctrl.maxTime"\n' +
            '    options="$ctrl.options"\n' +
            '    on-option-select="$ctrl.handleOptionSelect(option)"\n' +
            '    append-text="$ctrl.appendText"\n' +
            '    prepend-icon="$ctrl.prependIcon"\n' +
            '    date="$ctrl.date">\n' +
            '</h-timepicker>\n'
    };

    angular
        .module('components')
        .component('hTimepickerWrapper', HTimePickerWrapperComponentOptions);


})();


